const ShapeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.96048 4.45718C5.72107 3.18031 6.70064 2 7.99976 2C9.29888 2 10.2785 3.18031 10.039 4.45718L9.18405 9.01713C9.0772 9.58703 8.57959 10 7.99976 10C7.41993 10 6.92233 9.58703 6.81547 9.01713L5.96048 4.45718ZM9.49976 12.5C9.49976 13.3284 8.82819 14 7.99976 14C7.17134 14 6.49976 13.3284 6.49976 12.5C6.49976 11.6716 7.17134 11 7.99976 11C8.82819 11 9.49976 11.6716 9.49976 12.5Z"
        fill="#DA9227"
      />
    </svg>
  );
};
export default ShapeIcon;
